import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Stack — flexbox layout primitive. Vertical by default; use `direction="row"`
 * for horizontal. Use `gap` (1–8) to space children by design tokens.
 *
 * @example
 *   <Stack direction="row" align="center" justify="between" gap={4}>
 *     <Heading>Title</Heading>
 *     <Button>Save</Button>
 *   </Stack>
 */
export function Stack({ direction = 'column', align = 'stretch', justify = 'start', gap = 3, className, children, ...rest }) {
    const classes = ['osd-stack', className].filter(Boolean).join(' ');
    return (_jsx("div", { className: classes, "data-direction": direction, "data-align": align, "data-justify": justify, "data-gap": gap, ...rest, children: children }));
}
//# sourceMappingURL=Stack.js.map